<!-- SPINNER para la seleción del tipo de alarma (OCUPACION/LIBRE/MOVIMIENTO..) -->
<mat-form-field>
    <mat-label>{{opcion}}</mat-label>
    <mat-select [(ngModel)]="selectOpcion" (ngModelChange)="onOptionSelected()"> 
      <mat-option *ngFor="let option of opciones 
      "[value]="option.value">
      {{option.viewValue}}
      </mat-option>
    </mat-select>
  </mat-form-field>